export const environment = {
  production: true,
  apiurl: "https://taram-sales-app-api.azurewebsites.net/",
 // apiurl: "https://starr-api.ramarajusurgical.com/",
  //apiurl: "https://starr-api-prd.azurewebsites.net/",
  // apiurl: "https://starr-api.azurewebsites.net/",
  checkinDistance: 25,
  googleapimapkey: "AIzaSyCd5FIiqPs-EOzVU5stzYNAIf3PZz5upGE",
  angularurl: "https://starr.taramtextiles.com/",
  logo:"assets/images/taram_logo.svg"
};
